import { render, staticRenderFns } from "./ImageNotes.vue?vue&type=template&id=70a04116"
import script from "./ImageNotes.vue?vue&type=script&lang=js"
export * from "./ImageNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports